export const environment = {
  production: false,
  apiUrl:'https://api.ps.dev.billing-3ps-dev.awsnprd.external.telenet.be',
  oktaDomain: 'telenet-partners.oktapreview.com',
  oktaClientId: '0oa6y04l59YF8ZCXu0x7',
  issuerId: 'aus65hzs7788OWryG0x7',
  dynatraceUrl: 'https://js-cdn.dynatrace.com/jstag/1730e3799b9/bf31661kqj/5798345c1cffca6_complete.js'
};
